import React, { useEffect, createElement } from 'react';
export const MetaPixel = () => {
  useEffect(() => {
    // Add Meta Pixel base code with safer DOM insertion
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      // Safer approach: append to head instead of inserting before existing script
      b.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your Pixel ID
    window.fbq('init', '818665510721071');
    // Track PageView on initial load
    window.fbq('track', 'PageView');
    // Add noscript pixel image as a fallback (for browsers with JavaScript disabled)
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=818665510721071&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    // Clean up function to remove noscript element when component unmounts
    return () => {
      if (document.body.contains(noscript)) {
        document.body.removeChild(noscript);
      }
    };
  }, []);
  return null;
};
// Function to track purchase events - to be called on button clicks
export const trackPurchase = () => {
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_category: 'Recetario Fit',
      content_name: 'Recetario Fit para Airfryer + 6 bonos',
      value: 19990,
      currency: 'ARS'
    });
  }
};
// Additional standard event tracking functions you might need
export const trackAddToCart = (value = 19990, currency = 'ARS') => {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_category: 'Recetario Fit',
      content_name: 'Recetario Fit para Airfryer + 6 bonos',
      value,
      currency
    });
  }
};
export const trackCompleteRegistration = () => {
  if (window.fbq) {
    window.fbq('track', 'CompleteRegistration', {
      content_category: 'Recetario Fit',
      content_name: 'Recetario Fit para Airfryer + 6 bonos'
    });
  }
};
export const trackContact = () => {
  if (window.fbq) {
    window.fbq('track', 'Contact');
  }
};
// Need to declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}